import type { Country } from 'bundles/research/index/types';
import type { NewProperty } from './types';

export const buildEmptyProperty = (countryList: Country[]): NewProperty => {
  const country = countryList.filter(country => country.id !== 0)[0];
  const state = country.countryStates.length > 0 ? country.countryStates[0].code : '';
  return {
    address: '',
    country,
    city: '',
    state,
    zip: ''
  };
};
